export enum ContractReminderStatus {
  done = 'done',
  todo = 'todo',
  coming = 'coming',
  late = 'late'
}
